import { useQuery } from "@tanstack/react-query";
import { useApi } from "@core/api";

export const useGeography = () => {
  const api = useApi();

  const regionsQuery = useQuery({
    queryKey: ["regions"],
    queryFn: () => api["/geography/regionmodel"](),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  const countriesQuery = useQuery({
    queryKey: ["countries"],
    queryFn: () => api["/geography/countrymodel"](),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  const loading = regionsQuery.isLoading || countriesQuery.isLoading;
  const data = {
    regions: regionsQuery.data,
    countries: countriesQuery.data,
  };

  return {
    data,
    loading,
  };
};
